// tslint:disable
export var PartyRoleRelationshipTypes;
(function (PartyRoleRelationshipTypes) {
    // UNKN
    PartyRoleRelationshipTypes[PartyRoleRelationshipTypes["UNKN"] = 0] = "UNKN";
    // PATPSRB
    PartyRoleRelationshipTypes[PartyRoleRelationshipTypes["PATPSRB"] = 1] = "PATPSRB";
    // PATPINS
    PartyRoleRelationshipTypes[PartyRoleRelationshipTypes["PATPINS"] = 2] = "PATPINS";
    // PATSPBM
    PartyRoleRelationshipTypes[PartyRoleRelationshipTypes["PATSPBM"] = 3] = "PATSPBM";
    // PSRBSTE
    PartyRoleRelationshipTypes[PartyRoleRelationshipTypes["PSRBSTE"] = 4] = "PSRBSTE";
    // PATALTCNT
    PartyRoleRelationshipTypes[PartyRoleRelationshipTypes["PATALTCNT"] = 5] = "PATALTCNT";
    // PATPL
    PartyRoleRelationshipTypes[PartyRoleRelationshipTypes["PATPL"] = 6] = "PATPL";
    // PSRBPL
    PartyRoleRelationshipTypes[PartyRoleRelationshipTypes["PSRBPL"] = 7] = "PSRBPL";
    // PRVDPL
    PartyRoleRelationshipTypes[PartyRoleRelationshipTypes["PRVDPL"] = 8] = "PRVDPL";
    // PAYPL
    PartyRoleRelationshipTypes[PartyRoleRelationshipTypes["PAYPL"] = 9] = "PAYPL";
    // PAYCNT
    PartyRoleRelationshipTypes[PartyRoleRelationshipTypes["PAYCNT"] = 10] = "PAYCNT";
    // PLCNT
    PartyRoleRelationshipTypes[PartyRoleRelationshipTypes["PLCNT"] = 11] = "PLCNT";
    // SITECNT
    PartyRoleRelationshipTypes[PartyRoleRelationshipTypes["SITECNT"] = 12] = "SITECNT";
    // PHARCNT
    PartyRoleRelationshipTypes[PartyRoleRelationshipTypes["PHARCNT"] = 13] = "PHARCNT";
    // FoundCnt
    PartyRoleRelationshipTypes[PartyRoleRelationshipTypes["FoundCnt"] = 14] = "FoundCnt";
    // SrvPrvdSrvAgnt
    PartyRoleRelationshipTypes[PartyRoleRelationshipTypes["SrvPrvdSrvAgnt"] = 15] = "SrvPrvdSrvAgnt";
    // SrvPrvdOffCnt
    PartyRoleRelationshipTypes[PartyRoleRelationshipTypes["SrvPrvdOffCnt"] = 16] = "SrvPrvdOffCnt";
    // PracPsrbste
    PartyRoleRelationshipTypes[PartyRoleRelationshipTypes["PracPsrbste"] = 17] = "PracPsrbste";
    // PsrbstePrac
    PartyRoleRelationshipTypes[PartyRoleRelationshipTypes["PsrbstePrac"] = 18] = "PsrbstePrac";
})(PartyRoleRelationshipTypes || (PartyRoleRelationshipTypes = {}));
PartyRoleRelationshipTypes['FOUNDCNT'] = 14;
PartyRoleRelationshipTypes['SRVPRVDSRVAGNT'] = 15;
PartyRoleRelationshipTypes['SRVPRVDOFFCNT'] = 16;
PartyRoleRelationshipTypes['PRACPSRBSTE'] = 17;
PartyRoleRelationshipTypes['PSRBSTEPRAC'] = 18;
//# sourceMappingURL=PartyRoleRelationshipTypes.js.map